import { computed, ref, watch, Ref } from '@vue/composition-api';
import { trackEvent } from './../../../../utils/index';
import { AdgroupFormData } from '@tt4b/ttam-enums';
const ConfigMap = {
  'five-in-one': {
    searchResult: 'creat_campaign_targeting_searchbox_searchresult_impression',
    clearFilterKeyword: 'creat_campaign_targeting_searchbox_querycross_click',
    afterClickResultListItem: 'creat_campaign_targeting_searchbox_searchresult_click',
  },
};
// 上报相关
export function useInterestBehaviorTracer(props: {
  keyword: Ref<string>;
  searchResult: Ref<any>;
  type: string;
  adgroupData: Ref<AdgroupFormData>;
}) {
  const { keyword, searchResult, type, adgroupData } = props;
  const _searchResultTraceInfo = ref();
  const adgroupId = computed(() => adgroupData.value.adId || '');

  function resetSearchResultTracer() {
    _searchResultTraceInfo.value = {
      hasSent: false,
      searchKeyword: keyword.value,
      isValid: false,
      exposedItemIdsSet: new Set(),
      exposureTime: Date.now(),
      adgroup_id: adgroupId.value,
    };
  }

  resetSearchResultTracer();

  function searchResultTracer() {
    // eslint-disable-next-line prefer-const
    let { hasSent, isValid, searchKeyword, exposureTime, exposedItemIdsSet } = _searchResultTraceInfo.value;

    if (searchKeyword && !hasSent) {
      if (!isValid) {
        const exposureDuration = Date.now() - exposureTime;
        if (exposureDuration > 3000) {
          isValid = true;
        }
      }

      if (exposedItemIdsSet.size) {
        trackEvent(ConfigMap[type].searchResult, {
          is_valid: isValid ? '1' : '0',
          exposed_result_count: exposedItemIdsSet.size,
          search_keyword: searchKeyword,
          adgroup_id: adgroupId.value,
        });
      }

      _searchResultTraceInfo.value.hasSent = true;
    }
  }

  function onHideSearchResultList() {
    searchResultTracer();
  }

  function onExposeResultListItem(node) {
    const id = node?.data?.id;
    if (id) {
      _searchResultTraceInfo.value.exposedItemIdsSet.add(id);
    }
  }

  function afterClickResultListItem(node, index) {
    trackEvent(ConfigMap[type].afterClickResultListItem, {
      tag_type: node.scene,
      adgroup_id: adgroupId.value,
      result_no: index + 1,
    });
    _searchResultTraceInfo.value.isValid = true;
  }

  function onScrollResultList() {
    _searchResultTraceInfo.value.isValid = true;
  }

  function onSelectTreeInteraction(eventName) {
    if (eventName === 'clearFilterKeyword') {
      trackEvent(ConfigMap[type].clearFilterKeyword, { adgroup_id: adgroupId.value });
    } else if (eventName === 'scrollTreeOptions') {
      onScrollResultList();
    }
  }

  watch(searchResult, () => {
    searchResultTracer();
    resetSearchResultTracer();
  });

  return {
    onHideSearchResultList,
    onExposeResultListItem,
    afterClickResultListItem,
    onSelectTreeInteraction,
  };
}
